// Batch fetch — one IsFeatureEnabled call for the whole flag set
// (request.features / response.features per YTYardConsoleServiceModel).
export const FETCH_FEATURE_FLAGS = "FETCH_FEATURE_FLAGS";
export const FETCH_FEATURE_FLAGS_SUCCESS = "FETCH_FEATURE_FLAGS_SUCCESS";
export const FETCH_FEATURE_FLAGS_FAILURE = "FETCH_FEATURE_FLAGS_FAILURE";
